<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  created () {
    if (this.mobileCheck()) {
      window.location.href = 'http://www.weixuetec.com/mobile.html'
    }
  },
  methods: {
    mobileCheck () {
      const agent = navigator.userAgent || navigator.vendor || window.opera
      console.log(agent)
      var Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
      var flag = false
      flag = Agents.every(function (element, index, array) {
        return !(agent.indexOf(element) > 0)
      })
      return !flag
    }
  }
}
</script>

<style>
@import './assets/css/site.css';
#app {
  display: block;
  height: 100%;
}
</style>




// WEBPACK FOOTER //
// App.vue?1ff8db41